import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { BackendService } from '../../core/backend.service';
import { PerformanceStandard } from '../../viewmodels/performance-standard';

@Component({
  selector: 'hb-performance-standards-dialog',
  templateUrl: './performance-standards-dialog.component.html',
  styleUrls: ['./performance-standards-dialog.component.scss'],
})
export class PerformanceStandardsDialogComponent implements OnInit {
  @Input() isReadOnly = false;
  @Input() activeItemId: string = null;
  @Output() itemSelected: EventEmitter<PerformanceStandard> = new EventEmitter<PerformanceStandard>();
  performanceStandards: PerformanceStandard[] = [];
  filteredPerformanceStandards: PerformanceStandard[] = [];
  filterText: string = '';
  addition = {};

  @Input() isBuildPM: boolean = false;
  @Output() selectedItems: Subject<PerformanceStandard[]> = new Subject<PerformanceStandard[]>();
  _itemsFromCallingForm: PerformanceStandard[] = [];

  @Input()
  set itemsFromCallingForm(list: PerformanceStandard[]) {
    this._itemsFromCallingForm = list;
  }
  get itemsFromCallingForm(): PerformanceStandard[] { return this._itemsFromCallingForm; }

  constructor(public bsModalRef: BsModalRef,
    private backendService: BackendService) {

  }

  ngOnInit() {
    this.backendService.getAll<PerformanceStandard>(PerformanceStandard)
      .subscribe((result: PerformanceStandard[]) => {
        if (result) {
          this.performanceStandards = result;
          this.performanceStandards.forEach(item => {
            this.addition[item.performanceStandardId] = {
              isFullView: false,
              sortOrder: 'reference',
              isAscending: true,
            };
          });
          this.filterChanged();
          this.setItemSelectedFlag();
        }
      });
  }

  multiSelectAndClose() {
    this.selectedItems.next(this.itemsFromCallingForm);
    this.bsModalRef.hide();
  }

  onSelectClose(item) {
    this.itemSelected.emit(item as PerformanceStandard);
    this.bsModalRef.hide();
  }

  changeView(item) {
    this.addition[item.performanceStandardId].isFullView = !this.addition[item.performanceStandardId].isFullView;
  }

  orderBy(item, field) {
    const currField = this.addition[item.performanceStandardId].sortOrder;
    if (currField === field) {
      this.addition[item.performanceStandardId].isAscending = !this.addition[item.performanceStandardId].isAscending;
    } else {
      this.addition[item.performanceStandardId].sortOrder = field;
      this.addition[item.performanceStandardId].isAscending = true;
    }
    item.requirements = _.orderBy(item.requirements, [field], [this.addition[item.performanceStandardId].isAscending ? 'asc' : 'desc']);
  }

  getOrderClass(item, field) {
    const currOrdering = this.addition[item.performanceStandardId].sortOrder;
    if (currOrdering !== field) {
      return 'fa fa-arrows-alt-v gray-color';
    } else
      if (this.addition[item.performanceStandardId].isAscending) {
        return 'fa fa-long-arrow-alt-down';
      } else {
        return 'fa fa-long-arrow-alt-up';
      }
  }

  isItemSelected(item) {
    if (!item || !item.performanceStandardId || !this.activeItemId) {
      return false;
    }
    return (item.performanceStandardId.toUpperCase() === this.activeItemId.toUpperCase());
  }

  setItemSelectedFlag() {
    if (this.itemsFromCallingForm) {
      this.itemsFromCallingForm.forEach(element => {
        this.filteredPerformanceStandards.find(x => x.performanceStandardId === element.performanceStandardId).isSelected = true;
      });
    }
  }

  filterChanged() {
    if (!this.filterText.length) {
      this.filteredPerformanceStandards = this.performanceStandards;
      return;
    }
    this.filteredPerformanceStandards = _.filter(this.performanceStandards, item =>
    (item.reference.toUpperCase().includes(this.filterText.toUpperCase()) ||
      item.description.toUpperCase().includes(this.filterText.toUpperCase()) ||
      this.isItemSelected(item)),
    );
  }

  onChange_checkbox(e, id, item) {
    if (e.target.checked) {
      if (this._itemsFromCallingForm) {
        if (!this._itemsFromCallingForm.find(x => x.performanceStandardId === item.performanceStandardId)) {
          this._itemsFromCallingForm.push(item);
        }
      } else {
        this._itemsFromCallingForm.push(item);
      }
    } else {

      if (this._itemsFromCallingForm.find(x => x.performanceStandardId === item.performanceStandardId)) {
        this._itemsFromCallingForm.find(x => x.performanceStandardId === item.performanceStandardId);
        this._itemsFromCallingForm.splice(this._itemsFromCallingForm.indexOf(this._itemsFromCallingForm.find(x => x.performanceStandardId === item.performanceStandardId)), 1);
      }
    }
  }
}
